import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const FaqSection = () => {
    // State to manage which question is open
    const [openQuestion, setOpenQuestion] = useState(null);

    // Refs to manage the animation targets
    const answerRefs = useRef([]);
    answerRefs.current = [];

    // Function to add refs
    const addToRefs = (el) => {
        if (el && !answerRefs.current.includes(el)) {
            answerRefs.current.push(el);
        }
    };

    // Function to toggle the question
    const toggleQuestion = (question) => {
        setOpenQuestion(openQuestion === question ? null : question);
    };

    useEffect(() => {
        answerRefs.current.forEach((ref, index) => {
            if (openQuestion === index) {
                gsap.to(ref, { height: 'auto', opacity: 1, duration: 0.5 });
            } else {
                gsap.to(ref, { height: 0, opacity: 0, duration: 0.5 });
            }
        });
    }, [openQuestion]);

    // FAQ data
    const faqs = [
        { question: "How do I get started with bookings on the app?", answer: "Sign up, create your profile with your DJ bio, and set your availability. Our platform will match you with events that fit your style and schedule." },
        { question: "What kind of gigs can I expect to find?", answer: "From intimate private parties to large-scale festivals, our app caters to a wide range of events. You can choose gigs that align with your preferences and expertise." },
        { question: "How are payments handled?", answer: "We offer secure, timely payments through the app. Once you complete a gig, the payment will be processed and transferred to your account." },
        { question: "Can I manage multiple bookings at once?", answer: "Yes, our app is designed for efficient multi-booking management. Keep track of your gigs, schedules, and travel arrangements all in one place." },
        { question: "What if I need to cancel a booking?", answer: "We understand that plans can change. Our app provides a straightforward cancellation process, with policies in place to protect both you and the event organizer." },
        { question: "How can I increase my visibility to get more bookings?", answer: "Regularly upload up-to-date mixes and garner positive reviews from clients. Collaborate with other artists and participate in community events to broaden your reach. Most importantly, deliver exceptional performances that create a lasting impression, encouraging word-of-mouth referrals." },
    ];

    return (
        <div className="flex flex-col items-center gap-[64px] sm: sm:py-[96px] py-[48px] px-[24px]">

            <div className="flex flex-col items-center gap-[20px]">
                <h3 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                    Frequently asked questions
                </h3>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Everything you need to know about the product and billing.
                </span>
            </div>

            <div className="flex flex-col md:w-[768px] gap-[32px] w-full">
                {faqs.map((faq, index) => (
                    <div key={index} className="flex flex-col items-start mb-[16px] w-full">
                        <div className="flex items-start justify-between gap-[24px] w-full cursor-pointer" onClick={() => toggleQuestion(index)}>
                            <div className="flex flex-col gap-[8px]">
                                <h4 className='text-[#101828] font-[500] sm:text-[18px] text-[16px]'>
                                    {faq.question}
                                </h4>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" className='min-w-[32px]'>
                                <path d={openQuestion === index ? "M8 12H16" : "M12 8V16M8 12H16"} stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div ref={addToRefs} style={{ height: 0, overflow: 'hidden', opacity: 0 }}>
                            <p className='text-[#475467] mt-[8px]'>
                                {faq.answer}
                            </p>
                        </div>
                        <hr className='border-[#EAECF0]' />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqSection;
